<template>
    <el-dialog
            style="margin-top: -50px;"
            title="选择供应商物料分类"
            :close-on-click-modal="false"
            width="80%"
            :visible.sync="visible">
      <div style="text-align: center;">
        <el-transfer
                class="wf-position-bind"
                style="text-align: left;display: inline-block"
                :titles="titles"
                filterable
                filter-placeholder=""
                v-model="selectIds"
                :data="dataList">
        </el-transfer>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取消
        </el-button>
        <el-button size="small" type="primary" @click="dataFormSubmit()">确定
        </el-button>
      </span>
    </el-dialog>
  </template>
  
  <script>
    import { fetchMtlClass, fetchMtlClassByIds } from '@/controller/mdata'
    export default {
      data () {
        return {
          titles: ['物料分类列表', '已选择'],
          dataForm: {
            id: '',
            key: ''
          },
          nodeName: '',
          dataList: [],
          selectIds: [],
          visible: false
        }
      },
      methods: {
        init() {
          this.dataList = []
          this.selectIds = []
          this.visible = true

          fetchMtlClass({}, sessionStorage.getItem('mainBodyId')).then(data => {
            console.log("输出值了",data)
            if (data && data.code === '00') {
                
              data.body.forEach((item, idx) => {
                this.dataList.push({
                  label: item.materialGroupName,
                  key: item.id,
                  index: idx
                })
              })
            } else {
              this.dataList = []
            }
            this.dataListLoading = false
          })
        },
        dataFormSubmit() {
          if(this.selectIds.length < 1){
            this.$message({
              message: '至少需要选择一个物料分类才能保存',
              type: 'error'
            })
            return;
          }
          console.log("选中的数据",this.selectIds)
          const ids = this.selectIds
          //根据已经选择的id获取物料分类表的名称
          fetchMtlClassByIds({ids}).then(data =>{
            if(data && data.code == '00'){
              const result = data.body
              const newArray = result.map(item =>({
                materialGroupCode: item.materialGroupCode,
                materialGroupName: item.materialGroupName
              }))
              this.visible = false
              this.$emit("materialGroupNames",newArray)
       
              
            }
          }).catch(error => {
            console.log(error)
          })


        }
      }
    }
  </script>
  <style lang="scss" scoped>
    .wf-position-bind.el-transfer{
      /deep/ .el-transfer-panel{
        width: 350px;
        height: 450px;
        .el-transfer-panel__list.is-filterable{
          height: 350px;
        }
      }
    }
  </style>
  